﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListFakturaAdbChoose extends GuiListGeneric {

        constructor() {
            super("FakturaAdb");
        }

        protected override clickRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement> ) {
            e.preventDefault();
            const fakturaId = $("#FakturaId").val() as string;
            const id = $(e.target).closest("div.erz-list-element").data("id") as string | number;
            const selectUrl = $("div.erz-list").data("select-url") as string;
            const url = `${selectUrl}?fakturaId=${fakturaId}&adbId=${id}`;
            this.gotoUrl(url);
        }
    }
